import './EquipmentItem.css';const equipmentItem = "_equipmentItem_1qv63_1";
const equipmentItem__itemValue = "_equipmentItem__itemValue_1qv63_30";
const equipmentItem__singleTable = "_equipmentItem__singleTable_1qv63_52";
const styles = {
  equipmentItem,
  equipmentItem__itemValue,
  equipmentItem__singleTable
};
export {
  styles as default,
  equipmentItem,
  equipmentItem__itemValue,
  equipmentItem__singleTable
};
